import React, { memo } from "react";
import { useDispatch } from "react-redux";

import { fetchPatchVehicleConfirmation } from "Slices/stationConfirmation";

// TODO: un-comment it when implement the dispatch function
// import { ReactComponent as DispatchIcon } from "../assets/dispatch-icon.svg";

import { ActionsWrapper, ActionButton } from "./styles";

interface ActionsProps {
  sessionId: string;
  cloudConfirmations: CloudConfirmationType[];
  hmiButtonConfirmed: boolean;
  version: number;
}

export const Actions = memo(
  ({
    cloudConfirmations,
    sessionId,
    hmiButtonConfirmed,
    version,
  }: ActionsProps) => {
    const dispatch = useDispatch();

    return (
      <ActionsWrapper>
        {hmiButtonConfirmed ? (
          <ActionButton isDone={true}>RELEASED</ActionButton>
        ) : (
          <ActionButton isDisplayOnly={true}>
            Waiting for On-Vehicle
          </ActionButton>
        )}
        {cloudConfirmations.map((each) => {
          const { buttonId, confirmed } = each;
          if (confirmed) {
            return (
              <ActionButton key={buttonId} isDone={true}>
                RELEASED
              </ActionButton>
            );
          }
          return (
            <ActionButton
              key={buttonId}
              isConfirmationRequired={true}
              onClick={() => {
                const payload = {
                  button_id: buttonId,
                  session_id: sessionId,
                  version,
                  successMessage:
                    "The confirmation has been successfully delivered",
                };
                dispatch(fetchPatchVehicleConfirmation(payload));
              }}
            >
              Release Vehicle
            </ActionButton>
          );
        })}
      </ActionsWrapper>
    );
  }
);
